<template>
  <div>
    <!-- Snackbar for success messages -->
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    
    <v-row justify="center">
      <v-dialog v-model="dialogVisible" persistent max-width="500px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Download</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field 
                    variant="outlined" 
                    v-model="email_id" 
                    label="Email ID" 
                    prepend-inner-icon="mdi-email"
                    color="primary"
                    :rules="[v => !!v || 'Email is required']"
                    @input="validateEmail"
                    :error-messages="emailError"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3" @click="closeDialog">Cancel</v-btn>
            <v-btn variant="flat" color="primary" class="mb-3" @click="handleSubmit" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DownloadPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    apiEndpoint: {
      type: String,
      required: true
    },
    payload: {
      type: Object,
      default: () => {}
    },
    method: {
      type: String,
      default: 'post'
    }
  },
  data() {
    return {
      email_id: '',
      isEmailValid: true,
      emailError: '',
      number: 0,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 3000,
        title: null,
        visible: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id);
      }
    }
  },
  methods: {
    validateEmail() {
      const emails = this.email_id.split(',').map(email => email.trim());
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emails.length === 1 && !emailPattern.test(emails[0])) {
        this.emailError = 'Please enter a valid email';
        this.isEmailValid = false
        return;
      } else {
        this.isEmailValid = true
      }

      for (const email of emails) {
        if (!emailPattern.test(email)) {
          this.emailError = 'Please enter valid email ids separated by commas';
          this.isEmailValid = false
          return;
        } else {
          this.isEmailValid = true
        }
      }

      this.emailError = null;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.email_id = '';
      this.emailError = '';
      this.isEmailValid = true;
    },
    handleSubmit() {
      if (this.isEmailValid && this.email_id) {
        this.downloadConfirmation('submit');
      }
    },
    downloadConfirmation(type) {
      this.number++;
      this.$httpSecured[this.method](this.apiEndpoint, this.method === 'get' ? { params: this.payload } : { ...this.payload })
        .then(response => {
          if (response.data && (response.data.url || response.data.message)) {
            if (type === 'submit') {
              this.dialogVisible = false;
              this.email_id = '';
              this.$emit("success", response.data.message);
            } else {
              const link = document.createElement('a');
              link.href = response.data.url;
              link.target = '_blank';
              link.download = 'inventory.csv';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.$emit("success", response.data.message);
            }
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong: " + error);
          this.number = 0;
        });
    },
    showSnackbar(color, text) {
      this.snackbar = {
        color: color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert",
        mode: "multi-line",
        position: "top",
        timeout: 3000,
        title: color.charAt(0).toUpperCase() + color.slice(1),
        text: text,
        visible: true
      };
    },
    showAlert(alert_type, alert_message) {
      // Emit alert event to parent component
      this.$emit('show-alert', { type: alert_type, message: alert_message });
    }
  }
}
</script>

<style scoped>
.cancel-color {
  color: #666;
}
</style>
